import { observer } from 'mobx-react-lite'
import { useLocation } from 'react-router'
import { uiStore } from 'shared/store/uiStore'
import { EnumAccessPageKeys } from 'entities/ExportRouters/lib/checkAccessPage'
import { AccessLayout } from 'entities/ExportRouters'
import { NumbersPath } from 'pages/settings/pages/numbers/route/numbersPath'
import { BuyNumberRoutes } from 'pages/settings/pages/numbers/pages/BuyNumber/route/type'

export const BuyNumberAccessLayout = observer(() => {
  const location = useLocation()

  return (
    <AccessLayout
      name={EnumAccessPageKeys.numbers_settings_buy_number}
      onAccessDenied={() => {
        uiStore.changeRouteViaVue({
          method: 'replace',
          path: `${NumbersPath.root}`,
        })
      }}
      onAccessSuccess={() => {
        if (!location.pathname.includes(BuyNumberRoutes.chooseNumber)) {
          uiStore.changeRouteViaVue({
            method: 'replace',
            path: `${NumbersPath.buyNumber.stepsRoot}`,
          })
        }
      }}
    />
  )
})
